import React from 'react';
import OTPInput from 'react-otp-input';
import { Card, CardContent, Stack, Typography } from 'components/base';
import { SmsOutlinedIcon } from 'assets/icons';
import { Button } from 'components/atoms';
import { useQRScreenNavigation } from 'hooks/navigation/useQRSCreenNavigation';
import { iconDiv, otpInputContainerStyle, otpInputStyle } from '../../styles';
import { useQRStore } from '../../store/useQRStore';
import { useVerifyOTPCode } from '../../hooks/useVerifyOTPCode';
import { useSendVerificationCode } from '../../hooks/useSendVerificationCode';

export const EnterCode: React.FC = () => {
  const { codeToVerify, setCodeToVerify, mobileNumber } = useQRStore();
  const { verifyOTPLoading, handleVerifyOTP, error } = useVerifyOTPCode();
  const { handleSendVerificationCode, sendVerificationCodeLoading } =
    useSendVerificationCode();
  const { goToVerifyIdentity } = useQRScreenNavigation();

  return (
    <Card raised sx={{ maxWidth: '80%' }}>
      <CardContent>
        <Stack p={2} spacing={2}>
          <Stack sx={iconDiv} bgcolor="secondary.background">
            <SmsOutlinedIcon fontSize="large" color="secondary" />
          </Stack>
          <Typography variant="h5" color="text.primary" alignSelf="center">
            Enter Verification Code
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            A 4-digit code has been sent to {mobileNumber}. Please enter it
            below.
          </Typography>
          <OTPInput
            value={codeToVerify}
            onChange={setCodeToVerify}
            numInputs={4}
            renderInput={(props) => <input {...props} />}
            inputStyle={otpInputStyle}
            containerStyle={otpInputContainerStyle}
            shouldAutoFocus={true}
          />
          {error && (
            <Typography variant="body1" color="error" align="center">
              {error}
            </Typography>
          )}
          <Stack direction="row" justifyContent="space-between">
            <Button
              variant="textSecondary"
              onClick={handleSendVerificationCode}
              disabled={sendVerificationCodeLoading}
            >
              Resend Code
            </Button>
            <Button variant="textSecondary" onClick={goToVerifyIdentity}>
              Change Number
            </Button>
          </Stack>
          <Button onClick={handleVerifyOTP} isLoading={verifyOTPLoading}>
            Verify
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
